import {
    rejestrRoutes,
    slownikiRoutes,
    otherRoutes,
    raportyRoutes,
    konfiguracjaRoutes,
    osobyRoutes,
    profileRoutes,
    sprawozdaniaRoutes,
    komunikatyRoutes


} from "./index"
import ViewOperHome from "../../components/views/home/oper/ViewOperHome.jsx";

const startRoute = {
    path: "/",
    roles: ['any'],
    exact: true,
    forbidden: true,
    view: <ViewOperHome/>,
    mode: 'pass',

}

export const routesOper =
    [
        startRoute,
        ...rejestrRoutes,
        ...slownikiRoutes,
        ...otherRoutes,
        ...raportyRoutes,
        ...konfiguracjaRoutes,
        ...osobyRoutes,
        ...profileRoutes,
        ...sprawozdaniaRoutes,
        ...komunikatyRoutes
    ]